// @flow
import * as React from 'react';
import './alert.scss'
type Props = {
  alerts: {type: string, message: string}
  show: boolean
};
type State = {
};

class Alert extends React.Component<Props, State> {
  render() {
    const {alerts, show} = this.props
    return (
      <div className={`alert`}>{show && <div className={`alert-message${alerts.type}`}>{alerts.message}</div>}</div>
    );
  };
};

export default Alert
